<template> 

  <BaseModal 
    :showing="showing" 
    :handleClose="close"
  >
    <!-- HEADER -->
    <template #header>
      <h2 class="text-ppd-green-dark text-2xl font-bold text-teal-700">Crear nuevo levantamiento</h2>
    </template>

    <!-- BODY -->
    <template #body>
      <p class="text-gray-700 text-sm mb-4 ">
        ¿Desea crear un nuevo levantamiento? Esto borrará las geometrías actualmente dibujadas.
      </p> 
    </template>

    <!-- FOOTER -->
    <template #footer>
      <BaseButton @click="crearNuevo" icon="check">Aceptar</BaseButton>
      <BaseButton variant="danger" class="ml-2" @click="close" icon="times">Cerrar</BaseButton>
    </template>
  </BaseModal>
</template>

<script>  
 
import BaseButton from "./atoms/BaseButton.vue";
import BaseModal from "./atoms/BaseModal.vue";

export default { 
  name: "notice-modal",
  data() {
    return { 

    };
  },
  props: {
    showing: {
      required: true,
      type: Boolean
    },
    geometries: {
      required: true
    },
  },
  components: { 
    BaseButton,
    BaseModal
  },
   
  methods: { 
    close() {
      //this.reset();
      this.$emit("close");
    }, 
    crearNuevo(){
      this.$emit("createNew");
      this.$emit("close");
    } 
  },
  mounted() {
    
  }
};
</script>

<style scoped>
  .bg-semi-75 {
    background-color: rgba(0, 0, 0, 0.75);
  }
  .text-teal-700 {
    color: #6e5b25;
  } 
</style>
